import { useState } from 'react';
import { supabase } from '../lib/supabase';
import { useLogos } from './useLogos';

export function useLogoUpload() {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { setLogo } = useLogos();

  const uploadLogo = async (file: File, type: 'chatbot' | 'bot', chatbotPublicId: string) => {
    try {
      setUploading(true);
      setError(null);

      // Validation du type de fichier
      if (!file.type.startsWith('image/')) {
        throw new Error('Le fichier doit être une image.');
      }

      // Validation de la taille
      if (file.size > 2 * 1024 * 1024) {
        throw new Error('Fichier trop volumineux. Maximum 2MB.');
      }

      const fileExt = file.name.split('.').pop();
      const fileName = `${type}-${chatbotPublicId}-${Date.now()}.${fileExt}`;
      const filePath = `logos/${chatbotPublicId}/${fileName}`;

      // Upload du fichier
      const { error: uploadError } = await supabase.storage
        .from('chatbot-assets')
        .upload(filePath, file, {
          cacheControl: '3600',
          upsert: true
        });

      if (uploadError) {
        throw uploadError;
      }

      // Récupérer l'URL publique
      const { data: { publicUrl } } = supabase.storage
        .from('chatbot-assets')
        .getPublicUrl(filePath);

      // Mettre à jour le store avec la nouvelle URL
      await setLogo(type, publicUrl, chatbotPublicId);

      return publicUrl;

    } catch (err) {
      const message = err instanceof Error ? err.message : 'Erreur lors de l\'upload';
      setError(message);
      console.error('Upload error:', err);
      return null;
    } finally {
      setUploading(false);
    }
  };

  return {
    uploadLogo,
    uploading,
    error,
    clearError: () => setError(null)
  };
}